import {
    CcRequirement,
    CcRequirementParentChild,
    CcRequirementRevision,
    CcRequirementState,
    CcRequirementHistory,
    Lifecycle,
} from "server/models"
import { inferLiteral, OrderType, StateType } from "client/utils"
import { TableGroupedIds } from "client/components"
import * as types from "./types"


// assign requirements to lifecycle phase
export const setCcRequirementSelected = (selected: readonly number[]) => ({
    type: inferLiteral(types.CC_REQUIREMENT_SELECTED),
    selected,
})
export const setCcRequirementsOnSelect = (onSelect: types.RequirementsOnSelect) => ({
    type: inferLiteral(types.CC_REQUIREMENT_ON_SELECT),
    onSelect,
})


// list
export const setCcRequirementBaseRoute = (baseRoute: string) => ({
    type: inferLiteral(types.CC_REQUIREMENT_BASE_ROUTE),
    baseRoute,
})
export const setCcRequirementBaseReviewRoute = (baseRoute: string) => ({
    type: inferLiteral(types.CC_REQUIREMENT_BASE_REVIEW_ROUTE),
    baseRoute,
})
export const showCcRequirementColumnSettings = (show: boolean) => ({
    type: inferLiteral(types.CC_REQUIREMENT_COLUMN_SETTINGS),
    show,
})
export const setCcRequirementDictionariesLoaded = (loaded: boolean) => ({
    type: inferLiteral(types.CC_REQUIREMENT_DICTIONARIES_LOADED),
    loaded,
})


export const setCcRequirementList = (requirementList: types.RequirementList) => ({
    type: inferLiteral(types.CC_REQUIREMENT_LIST),
    requirementList,
})
export const setCcRequirementParentChild = (parentChild: readonly CcRequirementParentChild[]) => ({
    type: inferLiteral(types.CC_REQUIREMENT_PARENT_CHILD),
    parentChild,
})
export const setCcRequirementNested = (requirementGroupedIds: readonly TableGroupedIds[]) => ({
    type: inferLiteral(types.CC_REQUIREMENT_NESTED),
    requirementGroupedIds,
})
export const setCcRequirementIds = (requirementIds: readonly number[]) => ({
    type: inferLiteral(types.CC_REQUIREMENT_IDS),
    requirementIds,
})


export const setCcRequirementRevisionList = (requirementId: number, revisions: CcRequirementRevision[]) => ({
    type: inferLiteral(types.CC_REQUIREMENT_REVISION_LIST),
    requirementId,
    revisions,
})
export const setCcRequirementRevisionActive = (requirementId: number, revision: CcRequirementRevision) => ({
    type: inferLiteral(types.CC_REQUIREMENT_REVISION_ACTIVE_LIST),
    requirementId,
    revision,
})


export const setCcRequirementStateList = (requirementId: number, state: CcRequirementState) => ({
    type: inferLiteral(types.CC_REQUIREMENT_STATE_LIST),
    requirementId,
    state,
})
export const setCcRequirementHistoryList = (requirementId: number, historyList: CcRequirementHistory[]) => ({
    type: inferLiteral(types.CC_REQUIREMENT_HISTORY_LIST),
    requirementId,
    historyList,
})
export const setCcRequirementTempAnswerList = (requirementId: number, tempAnswers: types.RequirementTempAnswerByUser) => ({
    type: inferLiteral(types.CC_REQUIREMENT_TEMP_ANSWER_LIST),
    requirementId,
    tempAnswers,
})


export const setCcRequirementSort = (sortColumn: keyof CcRequirement, sortOrder: OrderType) => ({
    type: inferLiteral(types.CC_REQUIREMENT_SORT),
    sortColumn,
    sortOrder,
})
export const setCcRequirementFilters = (filters: types.RequirementFilters) => ({
    type: inferLiteral(types.CC_REQUIREMENT_FILTERS),
    filters,
})


// edit
export const setCcRequirementEdit = (requirement: CcRequirement) => ({
    type: inferLiteral(types.CC_REQUIREMENT_EDIT),
    requirement,
})
export const setCcRequirementLifecyclesEdit = (lifecycles: readonly Lifecycle[]) => ({
    type: inferLiteral(types.CC_REQUIREMENT_LIFECYCLES_EDIT),
    lifecycles,
})
export const setCcRequirementLifecyclePhaseListEdit = (phaseList: types.RequirementLifecyclePhaseList) => ({
    type: inferLiteral(types.CC_REQUIREMENT_LIFECYCLE_PHASE_LIST_EDIT),
    phaseList,
})


export const setCcRequirementReloadEdit = (value: boolean) => ({
    type: inferLiteral(types.CC_REQUIREMENT_RELOAD_EDIT),
    value,
})


export const setAssignedCcRequirementParents = (requirementId: number, parentIds: number[]) => ({
    type: inferLiteral(types.CC_REQUIREMENT_ASSIGNED_PARENTS),
    requirementId,
    parentIds,
})
export const setAssignedCcRequirementChildren = (requirementId: number, childIds: number[]) => ({
    type: inferLiteral(types.CC_REQUIREMENT_ASSIGNED_CHILDREN),
    requirementId,
    childIds,
})


export const setNotAssignedCcRequirementIds = (requirementIds: readonly number[]) => ({
    type: inferLiteral(types.CC_REQUIREMENT_NOT_ASSIGNED_IDS),
    requirementIds,
})
export const setNotAssignedCcRequirementSort = (sortColumn: keyof CcRequirement, sortOrder: OrderType) => ({
    type: inferLiteral(types.CC_REQUIREMENT_NOT_ASSIGNED_SORT),
    sortColumn,
    sortOrder,
})
export const setNotAssignedCcRequirementFilters = (filters: types.RequirementFilters) => ({
    type: inferLiteral(types.CC_REQUIREMENT_NOT_ASSIGNED_FILTERS),
    filters,
})
export const setNotAssignedCcRequirementSelected = (selected: readonly number[]) => ({
    type: inferLiteral(types.CC_REQUIREMENT_NOT_ASSIGNED_SELECTED),
    selected,
})


export const setCcRequirementVersionList = (
    requirementId: number,
    versionIds: readonly number[],
    versionList: types.RequirementVersionList,
) => ({
    type: inferLiteral(types.CC_REQUIREMENT_VERSION_LIST),
    requirementId,
    versionIds,
    versionList,
})


// review
export const setCcRequirementSelectedRequirementIds = (selected: readonly number[]) => ({
    type: inferLiteral(types.CC_REQUIREMENT_SELECTED_REQUIREMENT_IDS),
    selected,
})
export const setCcRequirementVisibleRequirementIds = (visible: readonly number[]) => ({
    type: inferLiteral(types.CC_REQUIREMENT_VISIBLE_REQUIREMENT_IDS),
    visible,
})


export const setCcRequirementReviewListLoadState = (state: StateType) => ({
    type: inferLiteral(types.CC_REQUIREMENT_REVIEW_LIST_LOAD_STATE),
    state,
})


// popup menu
export const setCcRequirementActive = (active: CcRequirement) => ({
    type: inferLiteral(types.CC_REQUIREMENT_ACTIVE),
    active,
})
export const setCcRequirementPopupMenuShow = (show: boolean) => ({
    type: inferLiteral(types.CC_REQUIREMENT_POPUP_MENU_SHOW),
    show,
})
export const setCcRequirementPopupMenuTarget = (target: HTMLElement) => ({
    type: inferLiteral(types.CC_REQUIREMENT_POPUP_MENU_TARGET),
    target,
})


// view history
export const setCcRequirementRequirementDetails = (details: CcRequirement) => ({
    type: inferLiteral(types.CC_REQUIREMENT_REQUIREMENT_DETAILS),
    details,
})
export const setCcRequirementRequirementState = (state: CcRequirementState) => ({
    type: inferLiteral(types.CC_REQUIREMENT_REQUIREMENT_STATE),
    state,
})
export const setCcRequirementRequirementHistory = (history: CcRequirementHistory[]) => ({
    type: inferLiteral(types.CC_REQUIREMENT_REQUIREMENT_HISTORY),
    history,
})
export const setCcRequirementTempAnswers = (answers: types.RequirementTempAnswerByUser) => ({
    type: inferLiteral(types.CC_REQUIREMENT_TEMP_ANSWERS),
    answers,
})
export const setCcRequirementTempAnswerVersions = (versions: types.RequirementTempAnswerVersionByUser) => ({
    type: inferLiteral(types.CC_REQUIREMENT_TEMP_ANSWER_VERSIONS),
    versions,
})
export const setCcRequirementTempAnswerHistory = (history: CcRequirementHistory) => ({
    type: inferLiteral(types.CC_REQUIREMENT_TEMP_ANSWER_HISTORY),
    history,
})
export const setCcRequirementReloadAnswer = (value: boolean) => ({
    type: inferLiteral(types.CC_REQUIREMENT_RELOAD_ANSWER),
    value,
})
